const groupRoleAssignmentConfig = {
  name: 'Group Role Assignment',
  endpoint: '/internal_admin/admin_kit/group_role_assignments',
  modelKey: 'rbac_group_role_assignment',

  columns: [
    { name: 'group_name', title: 'Group', type: 'link' },
    { name: 'role_name', title: 'Role' },
    { name: 'created_by_name', title: 'Created By' },
    { name: 'created_at', title: 'Created' },
  ],

  filters: [
    { name: 'q[group_name_cont]', label: 'Group' },
    { name: 'q[role_name_cont]', label: 'Role' },
  ],

  attributes: [
    { name: 'id', label: 'ID' },
    { name: 'group_name', label: 'Group' },
    { name: 'role_name', label: 'Role' },
    { name: 'created_by_name', label: 'Created By' },
    { name: 'created_at', label: 'Created At' },
    { name: 'updated_at', label: 'Updated At' },
  ],

  form: {
    fields: [
      {
        name: 'group_id',
        label: 'Group',
        type: 'typeahead',
        searchEndpoint:
          '/internal_admin/admin_kit/group_role_assignments/group_search',
        displayField: 'group_name',
        required: true,
      },
      {
        name: 'role_id',
        label: 'Role',
        type: 'typeahead',
        searchEndpoint:
          '/internal_admin/admin_kit/group_role_assignments/role_search',
        displayField: 'role_name',
        required: true,
      },
    ],
  },
};

export default groupRoleAssignmentConfig;
